import { render } from "./App.vue?vue&type=template&id=9b593b5a"
const script = {}

import exportComponent from "C:\\Users\\mariano.mertinat\\IdeaProjects\\fabri\\fabri-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__